import type { FlightSearchFormLabels } from "../../labels";

type PassengersDropdownLabelProperties = {
  adultsCount: number;
  childrenCount: number;
  infantsCount: number;
  labels: FlightSearchFormLabels["passengersDropdown"];
};

export const createTravelersDescription = ({
  adultsCount,
  childrenCount,
  infantsCount,
  labels,
}: PassengersDropdownLabelProperties) => {
  let description = "1 Adult";
  const adultString = adultsCount > 1 ? labels.adults : labels.adult;
  const childString = childrenCount > 1 ? labels.children : labels.child;
  const infantString = infantsCount > 1 ? labels.infants : labels.infant;

  if (adultsCount > 0) {
    description = `${adultsCount.toString()} ${adultString}`;
  }
  if (childrenCount > 0) {
    description += `, ${childrenCount.toString()} ${childString}`;
  }
  if (infantsCount > 0) {
    description += `, ${infantsCount.toString()} ${infantString}`;
  }
  return description;
};
export const passengersInputLabel = ({
  adultsCount,
  childrenCount,
  infantsCount,
  labels,
}: PassengersDropdownLabelProperties) => {
  let label = "";

  if (adultsCount > 0) {
    label += `${adultsCount.toString()} ${adultsCount === 1 ? labels.adult : labels.adults}`;
  }
  if (childrenCount > 0) {
    if (adultsCount > 0) {
      label += ", ";
    }
    label += `${childrenCount.toString()} ${childrenCount === 1 ? labels.child : labels.children}`;
  }
  if (infantsCount > 0 && adultsCount >= infantsCount) {
    label += ", ";
    label += `${infantsCount.toString()} ${infantsCount === 1 ? labels.infant : labels.infants}`;
  }

  const travelerCount = adultsCount + childrenCount + infantsCount;
  if (adultsCount > 0 && childrenCount > 0 && infantsCount > 0) {
    label = `${travelerCount.toString()} ${labels.travelers}`;
  }

  if (travelerCount === 0) {
    label = labels.travelers;
  }

  return label;
};
